import React, { useEffect, useState, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { setAccessToken, setRefreshToken } from '../api/token';
import { usersApi } from '../api';
import HrnbLoader from '../components/controls/HrnbLoader';
import HrnbAlert from '../components/controls/HrnbAlert';

export default function VkAuthCallback() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setCurrentUser } = useContext(UserContext);
    const [error, setError] = useState(null);

    useEffect(() => {
        const accessToken = searchParams.get('accessToken');
        const refreshToken = searchParams.get('refreshToken');

        if (!accessToken) {
            setError('Токен авторизации не получен. Попробуйте ещё раз.');
            return;
        }

        // Сохраняем токены
        setAccessToken(accessToken);
        if (refreshToken) {
            setRefreshToken(refreshToken);
        }

        // Загружаем пользователя
        const loadUser = async () => {
            try {
                const user = await usersApi.current();
                if (user.profiles && user.profiles.length > 0) {
                    user.profileId = user.profiles[0].id;
                }
                setCurrentUser(user);
                navigate('/cabinet', { replace: true });
            } catch (err) {
                console.error('[VkAuthCallback] Failed to load user:', err);
                // Даже без загрузки пользователя — токены уже сохранены
                navigate('/cabinet', { replace: true });
            }
        };

        loadUser();
    }, [searchParams, navigate, setCurrentUser]);

    if (error) {
        return (
            <div style={{ maxWidth: 480, margin: '60px auto', padding: 24 }}>
                <HrnbAlert type="danger">{error}</HrnbAlert>
                <div style={{ textAlign: 'center', marginTop: 16 }}>
                    <button
                        onClick={() => navigate('/login', { replace: true })}
                        style={{
                            padding: '10px 24px',
                            borderRadius: 8,
                            background: 'linear-gradient(90deg, #4f8cff, #6fd6ff)',
                            color: '#fff',
                            border: 'none',
                            cursor: 'pointer',
                        }}
                    >
                        Вернуться к авторизации
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={{ textAlign: 'center', marginTop: 80 }}>
            <HrnbLoader />
            <p style={{ color: '#8a9aaa', marginTop: 16 }}>
                Выполняется вход через ВКонтакте...
            </p>
        </div>
    );
}